import SignupPage from "./authentication/SignupPage";

const AuthPage = () => {
  return (
    <SignupPage/>
  );
};

export default AuthPage;
